(()=>{
'use strict';
if(window.HOFTheme&&window.HOFTheme.__ready)return;
const STORAGE_KEY='hof_team_theme_v1';
const LEGACY_ID_KEY='fanscore_school_id';
const LEGACY_SLUG_KEY='fanscore_team_slug';
const ARCADE_SLUG_KEY='nil_arcade_team_slug';
const DEFAULTS={id:'',slug:'',name:'Hall Of Fan',primary:'#1f5aa6',secondary:'#aeb6c2'};
const cleanHex=(value,fallback)=>{let x=String(value||'').trim();if(!/^#[0-9a-fA-F]{6}$/.test(x))x=fallback;return x.toLowerCase()};
const rgb=hex=>{const x=cleanHex(hex,'#000000').slice(1);return {r:parseInt(x.slice(0,2),16),g:parseInt(x.slice(2,4),16),b:parseInt(x.slice(4,6),16)}};
const hex=({r,g,b})=>'#'+[r,g,b].map(v=>Math.max(0,Math.min(255,Math.round(v))).toString(16).padStart(2,'0')).join('');
const mix=(a,b,t)=>{a=rgb(a);b=rgb(b);return hex({r:a.r+(b.r-a.r)*t,g:a.g+(b.g-a.g)*t,b:a.b+(b.b-a.b)*t})};
const luminance=value=>{const c=rgb(value);const v=[c.r,c.g,c.b].map(x=>{x/=255;return x<=.03928?x/12.92:Math.pow((x+.055)/1.055,2.4)});return .2126*v[0]+.7152*v[1]+.0722*v[2]};
const rgba=(value,a)=>{const c=rgb(value);return `rgba(${c.r},${c.g},${c.b},${a})`};
function normalize(team={}){
 const primary=cleanHex(team.primary||team.primary_color,DEFAULTS.primary);
 const secondary=cleanHex(team.secondary||team.accent_color,DEFAULTS.secondary);
 return {...DEFAULTS,...team,primary,secondary,
  primaryLight:mix(primary,'#ffffff',.38),primaryDark:mix(primary,'#000000',.48),
  secondaryLight:mix(secondary,'#ffffff',.38),secondaryDark:mix(secondary,'#000000',.48),
  onPrimary:luminance(primary)>.5?'#101318':'#ffffff',onSecondary:luminance(secondary)>.5?'#101318':'#ffffff'};
}
function apply(team,{persist=true,emit=true}={}){
 const t=normalize(team);
 const target=document.documentElement;
 const vars={
  '--hof-team-primary':t.primary,'--hof-team-secondary':t.secondary,
  '--hof-team-primary-light':t.primaryLight,'--hof-team-primary-dark':t.primaryDark,
  '--hof-team-secondary-light':t.secondaryLight,'--hof-team-secondary-dark':t.secondaryDark,
  '--hof-on-primary':t.onPrimary,'--hof-on-secondary':t.onSecondary,
  '--hof-team-glow':rgba(t.primary,.18)
 };
 Object.entries(vars).forEach(([k,v])=>target.style.setProperty(k,v));
 document.querySelectorAll('.hof-app,.fg-shell,.hof-game-shell,[data-hof-themed]').forEach(el=>Object.entries(vars).forEach(([k,v])=>el.style.setProperty(k,v)));
 const styleOptOut=!!document.querySelector('[data-hof-style-opt-out="true"]');
 if(!styleOptOut){document.body?.classList.add('hof-design-system');target.classList.add('hof-design-system');}
 if(persist){try{
  localStorage.setItem(STORAGE_KEY,JSON.stringify(t));
  if(t.id) localStorage.setItem(LEGACY_ID_KEY,String(t.id)); else localStorage.removeItem(LEGACY_ID_KEY);
  if(t.slug){localStorage.setItem(LEGACY_SLUG_KEY,String(t.slug));localStorage.setItem(ARCADE_SLUG_KEY,String(t.slug))}else{localStorage.removeItem(LEGACY_SLUG_KEY);localStorage.removeItem(ARCADE_SLUG_KEY)}
 }catch{}}
 if(emit)window.dispatchEvent(new CustomEvent('hof:team-theme',{detail:t}));
 return t;
}
function getTeam(){try{
 const stored=JSON.parse(localStorage.getItem(STORAGE_KEY)||'null');
 if(stored)return normalize(stored);
 const legacyId=localStorage.getItem(LEGACY_ID_KEY)||'';
 const legacySlug=localStorage.getItem(LEGACY_SLUG_KEY)||localStorage.getItem(ARCADE_SLUG_KEY)||'';
 return normalize({...DEFAULTS,id:legacyId,slug:legacySlug});
 }catch{return normalize(DEFAULTS)}}
function setTeam(team){return apply(team,{persist:true,emit:true})}
function clearTeam(){try{localStorage.removeItem(STORAGE_KEY);localStorage.removeItem(LEGACY_ID_KEY);localStorage.removeItem(LEGACY_SLUG_KEY);localStorage.removeItem(ARCADE_SLUG_KEY)}catch{}return apply(DEFAULTS,{persist:false,emit:true})}
function autoDetect(){
 const el=document.querySelector('[data-team-primary],[data-school-primary]');
 if(!el)return false;
 const primary=el.dataset.teamPrimary||el.dataset.schoolPrimary;
 const secondary=el.dataset.teamSecondary||el.dataset.schoolSecondary||DEFAULTS.secondary;
 if(primary){setTeam({id:el.dataset.teamId||el.dataset.schoolId||'',slug:el.dataset.teamSlug||el.dataset.schoolSlug||'',name:el.dataset.teamName||el.dataset.schoolName||'',primary,secondary});return true}
 return false;
}

function syncFromFanScore(detail={}){
 const id=detail.schoolId||detail.school_id||detail.id||'';
 const slug=detail.teamSlug||detail.schoolSlug||detail.team_slug||detail.slug||'';
 if(!id&&!slug)return;
 const current=getTeam();
 if((id&&String(current.id)===String(id))||(!id&&slug&&current.slug===slug))return;
 apply({...current,id:id||current.id,slug:slug||current.slug,name:detail.teamName||detail.schoolName||current.name,primary:detail.primary||detail.primary_color||current.primary,secondary:detail.secondary||detail.secondary_color||detail.accent_color||current.secondary},{persist:true,emit:true});
}
window.HOFTheme={__ready:true,setTeam,getTeam,clearTeam,apply,normalize};
apply(getTeam(),{persist:false,emit:false});
function safeSameOrigin(raw,fallback){try{const u=new URL(raw||fallback,location.origin);return u.origin===location.origin?u.pathname+u.search+u.hash:fallback}catch{return fallback}}
function injectReturnNavigation(){
 if(document.querySelector('[data-hof-root],[data-hof-game-center],[data-fanworks-root],[data-hof-return-nav]'))return;
 const p=new URLSearchParams(location.search||'');const requested=p.get('return_to');const gameCenter=p.get('game_center');if(!requested&&!gameCenter)return;
 const nav=document.createElement('nav');nav.setAttribute('data-hof-return-nav','');nav.setAttribute('aria-label','Hall Of Fan return navigation');
 const home=document.createElement('a');home.href=safeSameOrigin(requested,'/pages/hall-of-fan');home.textContent='← Hall Of Fan Home';nav.appendChild(home);
 if(gameCenter){nav.appendChild(document.createTextNode(' | '));const gc=document.createElement('a');gc.href=safeSameOrigin(gameCenter,'/pages/hall-of-fan-game-center');gc.textContent='Game Center';nav.appendChild(gc)}
 document.body?.insertBefore(nav,document.body.firstChild);
}
function injectPlatformNavigation(){
 if(document.querySelector('.hof-appnav,.hof-bottom-nav,.hof-gc-bottom,.hofg__bottom-nav,.hof-fs-appnav'))return;
 const path=location.pathname||'';const p=new URLSearchParams(location.search||'');
 const isFanScore=/\/pages\/fanscore/i.test(path);const isHallGame=!!(p.get('return_to')||p.get('game_center'));
 if(!isFanScore&&!isHallGame)return;
 const active=isFanScore?'play':(isHallGame?'play':'home');
 const items=[['home','/pages/hall-of-fan','⌂','Home'],['play','/pages/hall-of-fan-game-center','★','Play'],['guild','/pages/fan-guild','◉','Guild'],['works','/pages/fanworks','◆','FanWorks'],['me','/pages/hall-of-fan#me','●','Me']];
 const nav=document.createElement('nav');nav.className='hof-appnav';nav.setAttribute('data-hof-platform-nav','');nav.setAttribute('aria-label','Hall Of Fan app navigation');
 nav.innerHTML=items.map(x=>`<a href="${x[1]}" class="${x[0]===active?'is-active':''}"><span aria-hidden="true">${x[2]}</span><span>${x[3]}</span></a>`).join('');
 document.body?.appendChild(nav);document.body?.classList.add('hof-has-platform-nav');
}
document.addEventListener('DOMContentLoaded',()=>{if(!document.querySelector('[data-hof-style-opt-out="true"]'))document.body?.classList.add('hof-design-system');if(!autoDetect())apply(getTeam(),{persist:false,emit:false});injectReturnNavigation();injectPlatformNavigation()});
window.addEventListener('storage',e=>{if([STORAGE_KEY,LEGACY_ID_KEY,LEGACY_SLUG_KEY,ARCADE_SLUG_KEY].includes(e.key))apply(getTeam(),{persist:false,emit:true})});
window.addEventListener('fanscore:team-change',e=>syncFromFanScore(e.detail||{}));
})();
